/**
 * MSX GTM Tracking
 * Arricchisce il dataLayer con eventi ecommerce GA4, interazioni utente e hook pub/sub Trade.
 */
(function () {
  'use strict';

  if (window.__MSX_GTM_INITIALIZED__) return;
  window.__MSX_GTM_INITIALIZED__ = true;

  var context = window.__MSX_GTM_CONTEXT__ || {};
  var currency = (context.page && context.page.currency) || (context.shop && context.shop.currency) || 'EUR';

  function pushToDataLayer(payload) {
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push(payload);
    if (window.MSX_GTM_DEBUG) {
      console.log('[MSX GTM]', payload);
    }
  }

  function clearEcommerce() {
    pushToDataLayer({ ecommerce: null });
  }

  function moneyToFloat(cents) {
    if (cents === null || cents === undefined) return 0;
    return Number(cents) / 100;
  }

  function formatLineItem(item, index) {
    return {
      item_id: item.sku || String(item.variant_id || item.id),
      item_variant_id: String(item.variant_id || item.id),
      item_product_id: String(item.product_id),
      item_name: item.product_title || item.title,
      item_brand: item.vendor || '',
      item_category: item.product_type || '',
      item_variant: item.variant_title || item.variant_options ? item.variant_options.join(' / ') : '',
      price: moneyToFloat(item.final_price != null ? item.final_price : item.price),
      quantity: item.quantity || 1,
      index: index != null ? index + 1 : undefined,
      sku: item.sku || '',
      url: item.url || '',
      image: item.image || (item.featured_image && item.featured_image.url) || undefined,
    };
  }

  function formatProductVariant(variant, product) {
    return {
      item_id: variant.sku || String(variant.id),
      item_variant_id: String(variant.id),
      item_product_id: String(product.id),
      item_name: product.title,
      item_brand: product.vendor || '',
      item_category: product.type || '',
      item_variant: variant.title || '',
      price: moneyToFloat(variant.price),
      quantity: 1,
      sku: variant.sku || '',
      url: product.url || '',
    };
  }

  function formatProductCard(el) {
    return {
      item_id: el.dataset.productSku || el.dataset.productId,
      item_product_id: el.dataset.productId,
      item_name: el.dataset.productTitle || '',
      item_brand: el.dataset.productVendor || '',
      price: parseFloat(el.dataset.productPrice || '0', 10),
      item_category: el.dataset.productType || '',
      url: el.dataset.productUrl || '',
    };
  }

  function cartValue(items) {
    return items.reduce(function (sum, item) {
      return sum + moneyToFloat(item.final_line_price != null ? item.final_line_price : item.line_price || item.price * item.quantity);
    }, 0);
  }

  function pushEcommerceEvent(eventName, ecommerce) {
    clearEcommerce();
    pushToDataLayer({ event: eventName, ecommerce: ecommerce });
  }

  function getCartSnapshot() {
    return window.__MSX_CART_SNAPSHOT__ || [];
  }

  function setCartSnapshot(items) {
    window.__MSX_CART_SNAPSHOT__ = (items || []).map(function (item) {
      return { variant_id: item.variant_id, quantity: item.quantity };
    });
  }

  function diffCart(previousItems, nextItems) {
    var prevMap = {};
    var nextMap = {};
    var changes = { added: [], removed: [], updated: [] };

    previousItems.forEach(function (item) {
      prevMap[item.variant_id] = item.quantity;
    });

    nextItems.forEach(function (item) {
      nextMap[item.variant_id] = item.quantity;
    });

    Object.keys(nextMap).forEach(function (variantId) {
      var prevQty = prevMap[variantId] || 0;
      var nextQty = nextMap[variantId];
      if (nextQty > prevQty) {
        changes.added.push({ variant_id: Number(variantId), quantity: nextQty - prevQty });
      } else if (nextQty < prevQty) {
        changes.removed.push({ variant_id: Number(variantId), quantity: prevQty - nextQty });
      }
    });

    Object.keys(prevMap).forEach(function (variantId) {
      if (nextMap[variantId] === undefined) {
        changes.removed.push({ variant_id: Number(variantId), quantity: prevMap[variantId] });
      }
    });

    return changes;
  }

  async function fetchCart() {
    try {
      var cartUrl = (window.routes && window.routes.cart_url) || '/cart';
      var response = await fetch(cartUrl + '.js');
      if (!response.ok) return null;
      return await response.json();
    } catch (error) {
      return null;
    }
  }

  async function resolveCartData(cartData) {
    if (cartData && cartData.items) return cartData;
    return await fetchCart();
  }

  function findCartItem(items, variantId) {
    return items.find(function (item) {
      return String(item.variant_id) === String(variantId);
    });
  }

  function pushPageEcommerceEvents() {
    var pageType = context.page && context.page.type;

    if (pageType === 'product' && context.product) {
      var product = context.product;
      var variant = product.selected_or_first_available_variant || product.variants[0];
      if (!variant) return;

      pushEcommerceEvent('view_item', {
        currency: currency,
        value: moneyToFloat(variant.price),
        items: [formatProductVariant(variant, product)],
      });
      return;
    }

    if (pageType === 'collection' && context.collection) {
      var collection = context.collection;
      var items = (collection.products || []).slice(0, 50).map(function (product, index) {
        var v = product.variants && product.variants[0];
        return formatProductVariant(v || { id: product.id, price: product.price, title: 'Default', sku: '' }, product);
      });

      pushEcommerceEvent('view_item_list', {
        item_list_id: collection.handle,
        item_list_name: collection.title,
        items: items,
      });
      return;
    }

    if (pageType === 'cart' && context.cart && context.cart.items) {
      pushEcommerceEvent('view_cart', {
        currency: currency,
        value: moneyToFloat(context.cart.total_price),
        items: context.cart.items.map(formatLineItem),
      });
      return;
    }

    if (pageType === 'search' && context.search) {
      pushToDataLayer({
        event: 'search',
        search_term: context.search.terms,
        search_results_count: context.search.results_count,
      });
    }
  }

  function pushDomItemLists() {
    var lists = document.querySelectorAll('[data-msx-item-list]');
    lists.forEach(function (listEl) {
      var cards = listEl.querySelectorAll('.product-card-wrapper[data-product-id]');
      if (!cards.length) return;

      var items = Array.from(cards).map(function (card, index) {
        var item = formatProductCard(card);
        item.index = index + 1;
        return item;
      });

      pushEcommerceEvent('view_item_list', {
        item_list_id: listEl.dataset.msxItemList || 'dom_list',
        item_list_name: listEl.dataset.msxItemListName || listEl.dataset.msxItemList || 'Product list',
        items: items,
      });
    });
  }

  function trackCartUpdate(event) {
    resolveCartData(event.cartData).then(function (cartData) {
      if (!cartData || !cartData.items) return;

      var previousSnapshot = getCartSnapshot();
      var nextSnapshot = cartData.items.map(function (item) {
        return { variant_id: item.variant_id, quantity: item.quantity };
      });
      var changes = diffCart(previousSnapshot, nextSnapshot);

      if (event.source === 'product-form' && event.productVariantId) {
        var addedItem = findCartItem(cartData.items, event.productVariantId);
        if (addedItem) {
          pushEcommerceEvent('add_to_cart', {
            currency: currency,
            value: moneyToFloat(addedItem.final_price || addedItem.price),
            items: [formatLineItem(addedItem)],
          });
        }
      } else {
        changes.added.forEach(function (change) {
          var item = findCartItem(cartData.items, change.variant_id);
          if (!item) return;
          var formatted = formatLineItem(item);
          formatted.quantity = change.quantity;
          pushEcommerceEvent('add_to_cart', {
            currency: currency,
            value: moneyToFloat((item.final_price || item.price) * change.quantity),
            items: [formatted],
          });
        });

        changes.removed.forEach(function (change) {
          var item = findCartItem(cartData.items, change.variant_id);
          var payloadItem = item ? formatLineItem(item) : {
            item_variant_id: String(change.variant_id),
            quantity: change.quantity,
          };
          payloadItem.quantity = change.quantity;
          pushEcommerceEvent('remove_from_cart', {
            currency: currency,
            value: item ? moneyToFloat((item.final_price || item.price) * change.quantity) : 0,
            items: [payloadItem],
          });
        });
      }

      pushToDataLayer({
        event: 'cart_updated',
        cart: {
          item_count: cartData.item_count,
          total_price: moneyToFloat(cartData.total_price),
          currency: cartData.currency || currency,
          items: cartData.items.map(formatLineItem),
        },
        cart_update_source: event.source || 'unknown',
      });

      setCartSnapshot(cartData.items);
    });
  }

  function trackVariantChange(event) {
    var variant = event.data && event.data.variant;
    var product = context.product;
    if (!variant || !product) return;

    pushEcommerceEvent('select_item', {
      item_list_id: product.handle,
      item_list_name: product.title,
      items: [formatProductVariant(variant, product)],
    });

    pushToDataLayer({
      event: 'variant_change',
      product_id: String(product.id),
      variant_id: String(variant.id),
      variant_title: variant.title,
      variant_sku: variant.sku,
      variant_price: moneyToFloat(variant.price),
      variant_available: variant.available,
    });
  }

  function trackCartError(event) {
    pushToDataLayer({
      event: 'cart_error',
      cart_error_source: event.source || 'unknown',
      variant_id: event.productVariantId || null,
      error_message: event.message || event.errors || 'unknown_error',
    });
  }

  function cleanClickText(value) {
    if (value === null || value === undefined) return '';
    return String(value).trim().replace(/\s+/g, ' ').slice(0, 150);
  }

  function getElementClasses(element) {
    if (!element || element.className === undefined || element.className === null) return null;
    if (typeof element.className === 'string') return element.className;
    if (element.className.baseVal !== undefined) return element.className.baseVal;
    return String(element.className);
  }

  function getAriaLabelledByText(element) {
    if (!element || !element.getAttribute) return '';
    var labelledBy = element.getAttribute('aria-labelledby');
    if (!labelledBy) return '';
    return labelledBy
      .split(/\s+/)
      .map(function (id) {
        var labelEl = document.getElementById(id);
        return labelEl ? labelEl.textContent : '';
      })
      .join(' ');
  }

  function getNestedAltText(element) {
    if (!element || !element.querySelector) return '';
    var img = element.querySelector('img[alt]');
    return img ? img.getAttribute('alt') || '' : '';
  }

  function getDatasetTitle(element) {
    if (!element || !element.closest) return '';
    var titledEl = element.closest('[data-product-title], [data-msx-click-label]');
    if (!titledEl) return '';
    return titledEl.dataset.msxClickLabel || titledEl.dataset.productTitle || '';
  }

  function getClickLabel(interactiveElement, clickedElement) {
    clickedElement = clickedElement || interactiveElement;
    if (!interactiveElement) return '';

    var candidates = [
      clickedElement.getAttribute && clickedElement.getAttribute('aria-label'),
      interactiveElement.getAttribute && interactiveElement.getAttribute('aria-label'),
      clickedElement.getAttribute && clickedElement.getAttribute('title'),
      interactiveElement.getAttribute && interactiveElement.getAttribute('title'),
      clickedElement.getAttribute && clickedElement.getAttribute('alt'),
      getAriaLabelledByText(clickedElement),
      getAriaLabelledByText(interactiveElement),
      clickedElement.textContent,
      interactiveElement.textContent,
      interactiveElement.innerText,
      clickedElement.innerText,
      interactiveElement.value,
      interactiveElement.name,
      getNestedAltText(interactiveElement),
      getNestedAltText(clickedElement),
      getDatasetTitle(interactiveElement),
      getDatasetTitle(clickedElement),
      interactiveElement.id,
    ];

    for (var i = 0; i < candidates.length; i++) {
      var cleaned = cleanClickText(candidates[i]);
      if (cleaned) return cleaned;
    }

    return '';
  }

  function trackClick(event) {
    var clickedElement = event.target;
    var target = clickedElement.closest(
      'a, button, input[type="submit"], input[type="button"], summary, label, [role="button"], [role="link"]'
    );

    if (!target) {
      target = clickedElement.closest('[data-product-id], .card-wrapper, .product-card-wrapper') || clickedElement;
    }

    if (!target || target.dataset.msxGtmIgnore === 'true') return;

    var clickText = getClickLabel(target, clickedElement);
    var productCard = target.closest('.product-card-wrapper[data-product-id]');
    var isCheckout = target.name === 'checkout' || target.classList.contains('cart__checkout-button');
    var href = target.href || target.getAttribute('href') || null;
    var isOutbound = href && href.indexOf('http') === 0 && href.indexOf(window.location.origin) !== 0;

    var clickPayload = {
      event: 'element_click',
      click_text: clickText,
      click: {
        element: target.tagName ? target.tagName.toLowerCase() : 'unknown',
        text: clickText,
        clicked_element: clickedElement.tagName ? clickedElement.tagName.toLowerCase() : 'unknown',
        href: href,
        id: target.id || null,
        name: target.name || null,
        type: target.type || null,
        classes: getElementClasses(target),
        section: (function () {
          var sectionEl = target.closest('[data-section]');
          return sectionEl ? sectionEl.dataset.section : null;
        })(),
        product_id: productCard ? productCard.dataset.productId : null,
        product_title: productCard ? productCard.dataset.productTitle : null,
        list_id: (function () {
          if (!productCard) return null;
          var listEl = productCard.closest('[data-msx-item-list]');
          return listEl ? listEl.dataset.msxItemList : null;
        })(),
        page_type: context.page && context.page.type,
        page_path: window.location.pathname,
      },
    };

    pushToDataLayer(clickPayload);

    if (productCard && target.tagName.toLowerCase() === 'a') {
      var item = formatProductCard(productCard);
      var listEl = productCard.closest('[data-msx-item-list]');
      pushEcommerceEvent('select_item', {
        item_list_id: listEl ? listEl.dataset.msxItemList : 'product_grid',
        item_list_name: listEl ? listEl.dataset.msxItemListName || listEl.dataset.msxItemList : 'Product grid',
        items: [item],
      });
      pushToDataLayer({ event: 'product_click', product: item });
    }

    if (target.closest('header, .header, #header-group')) {
      pushToDataLayer({
        event: 'navigation_click',
        navigation: {
          text: clickText,
          href: href,
          zone: 'header',
        },
      });
    }

    if (target.closest('footer, .footer, #footer-group')) {
      pushToDataLayer({
        event: 'navigation_click',
        navigation: {
          text: clickText,
          href: href,
          zone: 'footer',
        },
      });
    }

    if (isCheckout) {
      resolveCartData(context.cart).then(function (cartData) {
        if (!cartData || !cartData.items) return;
        pushEcommerceEvent('begin_checkout', {
          currency: cartData.currency || currency,
          value: moneyToFloat(cartData.total_price),
          items: cartData.items.map(formatLineItem),
        });
      });
    }

    if (isOutbound) {
      pushToDataLayer({
        event: 'outbound_click',
        outbound: {
          url: href,
          text: clickText,
        },
      });
    }
  }

  var FORM_LEAD_STORAGE_KEY = 'msx_gtm_pending_form_lead';
  var FORM_LEAD_PUSHED_KEY = 'msx_gtm_form_lead_pushed';

  var FORM_ROOT_NAMES = {
    'forms-root-520437': 'dropshipping',
    'forms-root-143687': 'registration',
    'forms-root-143686': 'registration',
    'forms-root-142961': 'registration',
  };

  var THANK_YOU_PAGES = {
    'nuova-richiesta-inviata': 'dropshipping',
    'richiesta-ricevuta': 'dropshipping',
    'request-received': 'dropshipping',
  };

  function walkShadowDom(root, callback) {
    if (!root) return;
    callback(root);
    if (!root.querySelectorAll) return;

    root.querySelectorAll('*').forEach(function (element) {
      if (element.shadowRoot) {
        walkShadowDom(element.shadowRoot, callback);
      }
    });
  }

  function findShopifyFormsRoot(element) {
    if (!element || !element.closest) return null;
    return element.closest(
      '[data-forms-id^="forms-root"], shopify-forms, [id^="shopify-block-forms"], .shopify-app-block form'
    );
  }

  function getFormIdFromRoot(formsRoot) {
    if (!formsRoot) return 'unknown';
    if (formsRoot.dataset && formsRoot.dataset.formsId) return formsRoot.dataset.formsId;
    return formsRoot.id || 'shopify_form';
  }

  function getFormNameFromRoot(formsRoot) {
    var formId = getFormIdFromRoot(formsRoot);
    if (FORM_ROOT_NAMES[formId]) return FORM_ROOT_NAMES[formId];

    var pagePath = window.location.pathname;
    if (pagePath.indexOf('dropshipping') !== -1) return 'dropshipping';
    if (pagePath.indexOf('registraz') !== -1) return 'registration';
    if (pagePath.indexOf('contatt') !== -1) return 'contact';

    return formId;
  }

  function extractShopifyFormFields(container) {
    var fields = {};
    var labels = {};

    walkShadowDom(container, function (root) {
      if (!root.querySelectorAll) return;

      root.querySelectorAll('label').forEach(function (label) {
        var forId = label.getAttribute('for');
        if (forId) labels[forId] = label.textContent.trim();
      });

      root.querySelectorAll('input, textarea, select').forEach(function (input) {
        if (!input || input.type === 'hidden' || input.type === 'password') return;

        var key =
          input.name ||
          input.id ||
          input.getAttribute('aria-label') ||
          labels[input.id] ||
          input.placeholder ||
          input.type;

        if (!key) return;
        key = String(key).trim();

        if (input.type === 'checkbox') {
          fields[key] = input.checked;
          return;
        }

        if (input.type === 'radio') {
          if (input.checked) fields[key] = input.value;
          return;
        }

        if (input.value !== undefined && input.value !== '') {
          fields[key] = input.value;
        }
      });
    });

    return fields;
  }

  function normalizeLeadFields(fields) {
    var normalized = {
      raw_fields: fields,
      email: null,
      first_name: null,
      last_name: null,
      phone: null,
      company: null,
      full_name: null,
    };

    Object.keys(fields || {}).forEach(function (key) {
      var value = fields[key];
      if (value === null || value === undefined || value === '') return;

      var lowerKey = key.toLowerCase();

      if (!normalized.email && (lowerKey.indexOf('email') !== -1 || lowerKey.indexOf('e-mail') !== -1)) {
        normalized.email = value;
      } else if (!normalized.first_name && (lowerKey.indexOf('first') !== -1 || lowerKey === 'nome' || lowerKey === 'name')) {
        normalized.first_name = value;
      } else if (!normalized.last_name && (lowerKey.indexOf('last') !== -1 || lowerKey.indexOf('cognom') !== -1)) {
        normalized.last_name = value;
      } else if (!normalized.phone && (lowerKey.indexOf('phone') !== -1 || lowerKey.indexOf('tel') !== -1 || lowerKey.indexOf('mobile') !== -1)) {
        normalized.phone = value;
      } else if (
        !normalized.company &&
        (lowerKey.indexOf('company') !== -1 ||
          lowerKey.indexOf('aziend') !== -1 ||
          lowerKey.indexOf('ragione') !== -1 ||
          lowerKey.indexOf('business') !== -1 ||
          lowerKey.indexOf('piva') !== -1 ||
          lowerKey.indexOf('vat') !== -1)
      ) {
        normalized.company = value;
      } else if (!normalized.full_name && lowerKey.indexOf('name') !== -1) {
        normalized.full_name = value;
      }
    });

    if (!normalized.full_name && normalized.first_name) {
      normalized.full_name = [normalized.first_name, normalized.last_name].filter(Boolean).join(' ');
    }

    return normalized;
  }

  function storePendingFormLead(formsRoot) {
    var fields = extractShopifyFormFields(formsRoot);
    if (!Object.keys(fields).length) return;

    var leadData = {
      form_id: getFormIdFromRoot(formsRoot),
      form_name: getFormNameFromRoot(formsRoot),
      form_type: 'shopify_forms',
      fields: fields,
      page_path: window.location.pathname,
      page_title: document.title,
      submitted_at: new Date().toISOString(),
    };

    sessionStorage.setItem(FORM_LEAD_STORAGE_KEY, JSON.stringify(leadData));

    pushToDataLayer({
      event: 'form_submit_attempt',
      form_submission: leadData,
      form_user: normalizeLeadFields(fields),
    });
  }

  function pushFormLeadSuccess(leadData, source) {
    var dedupeKey = [leadData.submitted_at, leadData.form_id, leadData.page_path].join('|');
    if (sessionStorage.getItem(FORM_LEAD_PUSHED_KEY) === dedupeKey) return;
    sessionStorage.setItem(FORM_LEAD_PUSHED_KEY, dedupeKey);

    var normalized = normalizeLeadFields(leadData.fields || {});

    pushToDataLayer({
      event: 'generate_lead',
      form_submission: {
        form_id: leadData.form_id,
        form_name: leadData.form_name,
        form_type: leadData.form_type || 'shopify_forms',
        source_page: leadData.page_path,
        thank_you_page: window.location.pathname,
        fields: leadData.fields,
        tracking_source: source,
      },
      form_user: {
        email: normalized.email,
        first_name: normalized.first_name,
        last_name: normalized.last_name,
        full_name: normalized.full_name,
        phone: normalized.phone,
        company: normalized.company,
      },
      lead: normalized,
    });

    sessionStorage.removeItem(FORM_LEAD_STORAGE_KEY);
  }

  function pushStoredFormLeadIfThankYouPage() {
    var pageHandle = (context.content_page && context.content_page.handle) || '';
    var thankYouFormName = THANK_YOU_PAGES[pageHandle];

    if (!thankYouFormName) return;

    var stored = sessionStorage.getItem(FORM_LEAD_STORAGE_KEY);

    if (!stored) {
      pushToDataLayer({
        event: 'generate_lead',
        form_submission: {
          form_name: thankYouFormName,
          form_type: 'shopify_forms',
          thank_you_page: window.location.pathname,
          tracking_source: 'thank_you_page_without_session_data',
        },
      });
      return;
    }

    try {
      var leadData = JSON.parse(stored);
      var ageMs = Date.now() - new Date(leadData.submitted_at).getTime();
      if (ageMs > 10 * 60 * 1000) {
        sessionStorage.removeItem(FORM_LEAD_STORAGE_KEY);
        return;
      }

      leadData.form_name = leadData.form_name || thankYouFormName;
      pushFormLeadSuccess(leadData, 'thank_you_page');
    } catch (error) {
      sessionStorage.removeItem(FORM_LEAD_STORAGE_KEY);
    }
  }

  function interceptShopifyFormsFetch() {
    if (window.__MSX_FORMS_FETCH_HOOKED__) return;
    window.__MSX_FORMS_FETCH_HOOKED__ = true;

    var originalFetch = window.fetch;
    window.fetch = function () {
      var request = arguments[0];
      var url = typeof request === 'string' ? request : request && request.url ? request.url : '';

      return originalFetch.apply(this, arguments).then(function (response) {
        if (
          response &&
          response.ok &&
          (url.indexOf('/forms/') !== -1 ||
            url.indexOf('forms.shopify') !== -1 ||
            url.indexOf('form_submissions') !== -1)
        ) {
          var stored = sessionStorage.getItem(FORM_LEAD_STORAGE_KEY);
          if (stored) {
            try {
              pushFormLeadSuccess(JSON.parse(stored), 'shopify_forms_api');
            } catch (error) {
              /* ignore */
            }
          }
        }
        return response;
      });
    };
  }

  function trackShopifyForms() {
    interceptShopifyFormsFetch();

    document.addEventListener(
      'click',
      function (event) {
        var formsRoot = findShopifyFormsRoot(event.target);
        if (!formsRoot) return;

        var submitBtn = event.target.closest(
          'button, input[type="submit"], [type="submit"], [data-testid*="submit"], [class*="submit"]'
        );
        if (!submitBtn) return;

        setTimeout(function () {
          storePendingFormLead(formsRoot);
        }, 0);
      },
      true
    );

    document.addEventListener(
      'submit',
      function (event) {
        var formsRoot = findShopifyFormsRoot(event.target);
        if (!formsRoot) return;
        setTimeout(function () {
          storePendingFormLead(formsRoot);
        }, 0);
      },
      true
    );
  }

  function trackFormSubmit(event) {
    var form = event.target;
    if (!(form instanceof HTMLFormElement)) return;

    pushToDataLayer({
      event: 'form_submit',
      form: {
        id: form.id || null,
        name: form.name || null,
        action: form.action || null,
        method: (form.method || 'get').toLowerCase(),
        classes: form.className || null,
      },
    });

    if (form.matches('form[action*="/search"]') || form.id === 'FacetFiltersForm' || form.classList.contains('search')) {
      var input = form.querySelector('input[name="q"], input[type="search"]');
      if (input && input.value) {
        pushToDataLayer({
          event: 'search',
          search_term: input.value.trim(),
          search_location: form.id || form.className || 'form',
        });
      }
    }
  }

  function trackCartDrawer() {
    var cartDrawer = document.querySelector('cart-drawer');
    if (!cartDrawer) return;

    var observer = new MutationObserver(function () {
      if (!cartDrawer.classList.contains('active')) return;

      resolveCartData(context.cart).then(function (cartData) {
        if (!cartData || !cartData.items) return;
        pushEcommerceEvent('view_cart', {
          currency: cartData.currency || currency,
          value: moneyToFloat(cartData.total_price),
          items: cartData.items.map(formatLineItem),
        });
        pushToDataLayer({ event: 'cart_drawer_open' });
      });
    });

    observer.observe(cartDrawer, { attributes: true, attributeFilter: ['class'] });
  }

  function trackScrollDepth() {
    var thresholds = [25, 50, 75, 100];
    var reached = {};

    function onScroll() {
      var doc = document.documentElement;
      var scrollTop = window.scrollY || doc.scrollTop;
      var height = doc.scrollHeight - doc.clientHeight;
      if (height <= 0) return;

      var percent = Math.round((scrollTop / height) * 100);
      thresholds.forEach(function (threshold) {
        if (percent >= threshold && !reached[threshold]) {
          reached[threshold] = true;
          pushToDataLayer({
            event: 'scroll_depth',
            scroll_depth_threshold: threshold,
            scroll_depth_percent: percent,
            page_path: window.location.pathname,
          });
        }
      });
    }

    window.addEventListener('scroll', onScroll, { passive: true });
  }

  function bindPubSub() {
    if (typeof subscribe !== 'function' || typeof PUB_SUB_EVENTS === 'undefined') return;

    subscribe(PUB_SUB_EVENTS.cartUpdate, trackCartUpdate);
    subscribe(PUB_SUB_EVENTS.variantChange, trackVariantChange);
    subscribe(PUB_SUB_EVENTS.cartError, trackCartError);
  }

  function init() {
    pushStoredFormLeadIfThankYouPage();
    pushPageEcommerceEvents();
    pushDomItemLists();
    bindPubSub();
    trackShopifyForms();
    trackCartDrawer();
    trackScrollDepth();

    document.addEventListener('click', trackClick, true);
    document.addEventListener('submit', trackFormSubmit, true);

    pushToDataLayer({
      event: 'msx_tracking_ready',
      tracking_version: '1.1.0',
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  window.MSX_GTM = {
    push: pushToDataLayer,
    getContext: function () {
      return window.__MSX_GTM_CONTEXT__ || {};
    },
    debug: function (enabled) {
      window.MSX_GTM_DEBUG = enabled !== false;
    },
  };
})();
